import { api } from './Api';
import { restaurantLocalDate, validateStaffTipRange } from '../utils/staff-tip-utils';

export const getStaffTips = async (id, { start_date, end_date, signal }) => {
  const validation = validateStaffTipRange(start_date, end_date);
  if (validation) throw Object.assign(new Error(validation), { status: 400 });
  const report = await api.get(`/restmanager/${id}/report/tips`,
    { start_date, end_date }, { signal, noAutoRetry: true });
  // Fail closed rather than presenting a malformed or cross-restaurant response.
  const notConfigured = report?.state === 'not_configured' &&
    report.configured === false && report.available === false;
  const configured = ['empty', 'ready', 'incomplete'].includes(report?.state) &&
    report.configured === true && report.available === true;
  if (String(report?.restaurant_id) !== String(id) ||
      report.start_date !== start_date || report.end_date !== end_date ||
      report.inclusive !== true || (!notConfigured && !configured) ||
      !report.timezone || (configured && (!Array.isArray(report.periods) ||
        !report.periods.length || !Array.isArray(report.days) || !report.totals))) {
    throw new Error('Invalid staff tip report response.');
  }
  // Validate the server's timezone instead of falling back to the reader's clock.
  restaurantLocalDate(report.timezone);
  return report;
};

export const staffTipEligibility = (restaurant) => {
  const metadata = restaurant?.staff_tips;
  const expected = { enrolled: true, not_enrolled: false,
    configuration_error: null, access_denied: null, unavailable: null };
  const valid = metadata && Object.prototype.hasOwnProperty.call(expected, metadata.state) &&
    metadata.enrolled === expected[metadata.state];
  return valid ? metadata.state : 'unknown';
};

export const staffTipEligibilityMessage = (state) => ({
  not_enrolled: 'Staff Tips is not enabled for this restaurant.',
  access_denied: 'You do not have permission to view Staff Tips for this restaurant.',
  configuration_error: 'Staff Tips configuration needs attention. Contact Eatzy support.',
  unavailable: 'Staff Tips availability could not be checked. Please retry.',
  unknown: 'Staff Tips eligibility is unknown or unsupported. Refresh restaurant information to retry.',
  network_error: 'Staff Tips availability could not be loaded. Please retry.',
}[state]);

export const staffTipsErrorMessage = (error) => {
  switch (Number(error?.status)) {
    case 401: return 'Your session could not be verified. Sign in again to view Staff Tips.';
    case 403: return 'You do not have permission to view Staff Tips for this restaurant. Contact an Owner or Manager to check your restaurant access.';
    case 409: return 'Staff Tips configuration needs attention. Contact Eatzy support; no totals are available.';
    case 400: return 'This date range could not be processed. Choose a narrower range (at most 366 inclusive days); large shift and fee configurations may require fewer days.';
    default: return 'Staff Tips could not be loaded. Please retry. If this continues, contact support with the request reference. No totals are available.';
  }
};
